module.exports = __webpack_public_path__ + "static/bio-photo-dfd9713a22fe5426956be0c4ef6ff235.png";